var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangepasswordDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 16.173,
    viewBox: "0 0 15.5 16.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161157",
    "data-name": "Group 161157",
    transform: "translate(-25.25 -577.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161156",
    "data-name": "Group 161156",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161150",
    "data-name": "Group 161150",
    transform: "translate(11.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "password-svgrepo-com",
    d: "M12.5,8.5v-1a1,1,0,0,0-1-1H1.5a1,1,0,0,0-1,1v6.673a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1V12.5m0-4h-4a2,2,0,0,0,0,4h4m0-4a2,2,0,0,1,0,4m-9-6v-3a3,3,0,0,1,6,0v3",
    transform: "translate(14 577)",
    fill: "none",
    stroke: "#2d68fe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140387",
    "data-name": "Rectangle 140387",
    width: 1,
    height: 1,
    transform: "translate(22 587)",
    fill: "#2d68fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140388",
    "data-name": "Rectangle 140388",
    width: 1,
    height: 1,
    transform: "translate(24 587)",
    fill: "#2d68fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140389",
    "data-name": "Rectangle 140389",
    width: 1,
    height: 1,
    transform: "translate(26 587)",
    fill: "#2d68fe"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140390",
    "data-name": "Rectangle 140390",
    width: 14,
    height: 14,
    transform: "translate(26 578)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepasswordDarkIcon);
export default __webpack_public_path__ + "static/media/changepassword-dark-icon.a64a97771534659b058ed58763247cd7.svg";
export { ForwardRef as ReactComponent };